<template>
  <div class="top">
    <div class="image">
        <el-carousel v-show="showLunbo"  ref="carousel" weight="100%" :height="lunboHeight" trigger="click" arrow="never" @change="changeLb" :interval="intervalLb">
          <el-carousel-item  :key="1">
            <img class="lunbo-item" :style="lunboImageStyle" :src="backgroundImage"/>
<!--            <video :style="lunboImageStyle" id="lunboVideo"  class="video lunbo-item" src="../../assets/video/lbsp.mp4" autoplay muted loop="loop"></video>-->
          </el-carousel-item>
          <el-carousel-item  :key="2" :style="lunboImageStyle">

            <img class="lunbo-item" :style="lunboImageStyle" :src="backgroundImage2"/>
          </el-carousel-item>
          <el-carousel-item  :key="3">

            <img class="lunbo-item" :style="lunboImageStyle" :src="backgroundImage3"/>
          </el-carousel-item>
        </el-carousel>

        <el-image id="banner" @click="clickBanner" :class="{'find-job':bannerSrc=='/static/img/join-us-banner.3a22ab2.jpg'&&!showLunbo}" v-show="showImage" :src="bannerSrc"></el-image>

    </div>


    <div class="top-bar" :class="{'jjfa':showJjfa}">
        <div class="bw">
          <div class="kkws-icon" @click="clickLogo">
            <img :src="kkLogo"></img>
          </div>

          <div class="top-bar-menu" >
            <ul class="m-item">
              <li class="m-item" @click="clickBar(0)">首页</li>
              <li class="m-item" @click="clickBar(1)">关于我们</li>
              <li style="position: relative" class="services m-item">
                <span class="services" @click="clickBar(3)">产品&解决方案与服务</span>
                <div class="jjfa-fw" v-show="showMenu">
                  <ul :style="a" class="nav-menu">
                    <li class="j-class" @click="clickClass(2)">业务类<img v-show="currentType==2" src="../../assets/img/nav-point.png" /></li>
                    <li class="j-class" @click="clickClass(3)">营销类<img v-show="currentType==3" src="../../assets/img/nav-point.png" /></li>
                    <li class="j-class" @click="clickClass(4)">平台类<img v-show="currentType==4" src="../../assets/img/nav-point.png" /></li>
                    <li class="j-class" @click="clickClass(1)">管理类<img v-show="currentType==1" src="../../assets/img/nav-point.png" /></li>
                    <li class="j-class" @click="clickClass(5)">方案&服务<img v-show="currentType==5" src="../../assets/img/nav-point.png" /></li>
                  </ul>
                  <div class="nav-content">
                    <span class="j-class" v-for="p in productList" v-text="getProductTitle(p)" @click="clickProduct(p)">私人银行财富管理系统</span>
                  </div>
                </div>
              </li>
              <li class="m-item" @click="clickBar(2)">经典案例</li>
              <li class="m-item" @click="clickBar(4)">新闻中心</li>
              <li class="m-item" @click="clickBar(5)">加入我们</li>
            </ul>
          </div>
        </div>
    </div>

    <div v-if="ffTtp" class="top-ff-tip">
      <a href="https://img.kkws.cn:8089/files/d2a4d1e2-a8f9-4aa9-90d4-a9c7b4d2778e.png" target="_blank">近期有不法分子以北京开科唯识技术股份有限公司的名义发布虚假招聘信息欺诈求职者，严重损害了我司形象，影响我司正常的招聘工作。为防止不法分子再利用我司名义以招聘为由要求应聘人员支付或转账故作如下声明，详情请查看>></a>
      <img src="../../assets/img/ff-tip-delete.svg" @click="ffTtp=false"/>
    </div>
  </div>

</template>

<script>
  import request from "../../utils/request";
  import $ from 'jquery'
  export default {
    data() {
      return {
        ffTtp:true,
        t1:true,
        t2:false,
        bannerSrc:"",
        kkLogo:require('../../assets/img/white-logo.png'),
        backgroundImage:require('../../assets/img/desktop/lunbo1.jpg'),
        backgroundImage2:require('../../assets/img/desktop/lunbo2.jpg'),
        backgroundImage3:require('../../assets/img/desktop/lunbo3.jpg'),
        lbVideo:require('../../assets/img/lbwz.png'),
        lbVideo2:require('../../assets/img/lbwz.png'),
        newsBannerSrc:require('../../assets/img/news/newsBanner.jpg'),
        joinUsBannerSrc:require('../../assets/img/join-us/join-us-banner.jpg'),
        solutionBnnerSrc:require('../../assets/img/solution/solutionBanner.jpg'),
        aboutUsBnnerSrc:require('../../assets/img/about-us/gsjj.jpg'),
        zpBannerSrc:require('../../assets/img/desktop/zzns2.jpg'),
        showVideo:true,
        intervalLb:7000,
        showJjfa:false,
        showMenu:false,
        alwaysShowJjfa:false,
        showLunbo:true,
        currentLunboIndex:0,
        showLunboWz:true,
        showImage:false,
        overJjFa:false,
        lunboHeight:"950px",
        lunboWeight:"1920px",
        barBackgroudImage:require('../../assets/img/bar-background.png'),
        a:{
          // backgroundImage: "url(" + require("../../assets/img/bar-background.png") + ") ",
          // backgroundPosition: "center center",
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover",
          backgroundColor:"#0093DD"
        },
        lunboImageStyle:{
          width:"950px"
        },
        marketingList:[],
        managementList:[],
        businessList:[],
        platformList:[],
        solutionList:[],
        productList:[],
        currentType:2,//默认为1
        productClassList:['managementClass','businessClass','marketingClass','platformClass'],
        tempShowJjfa:false,
        tempKklogo:require('../../assets/img/blue-logo.png'),
        calculated:false,//正在计算
      };
    },
    computed:{
       currentRouter(){
         return this.$store.getters.getcurrentRouter;
       }
   },
    watch:{
      currentRouter(newVal,oldVal){
        let to={
          path:newVal
        }
        if(to.path=="/main/desktop"){
          this.showLunbo=true
          this.showImage=false
          this.showJjfa=false
          this.alwaysShowJjfa=false
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/news"){
          document.body.scrollIntoView()
          this.showLunbo=false
          this.showImage=true
          this.showJjfa=false
          this.alwaysShowJjfa=false
          this.kkLogo=require('../../assets/img/white-logo.png')
          this.bannerSrc=this.newsBannerSrc;
        }else if(to.path=="/main/newsDetails"){
          this.showLunbo=false
          this.showImage=false
          this.showJjfa=true
          this.alwaysShowJjfa=true
          this.kkLogo=require('../../assets/img/blue-logo.png')
        }else if(to.path=="/main/joinUs"){
          this.showLunbo=false
          this.showImage=true
          this.showJjfa=true
          this.alwaysShowJjfa=true
          this.bannerSrc=this.joinUsBannerSrc
          this.kkLogo=require('../../assets/img/blue-logo.png')
        }else if(to.path=="/main/solutionAndServices"){
          this.showLunbo=false
          this.showImage=true
          this.showJjfa=false
          this.alwaysShowJjfa=false
          this.bannerSrc=this.solutionBnnerSrc
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/productDetails"){
          this.showLunbo=false
          this.showImage=true
          this.showJjfa=false
          this.alwaysShowJjfa=false
          this.bannerSrc=this.solutionBnnerSrc
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/aboutUs"){
          this.showLunbo=false
          this.showImage=true
          this.showJjfa=false
          this.alwaysShowJjfa=false
          this.bannerSrc=this.aboutUsBnnerSrc
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/solutionDetails"){
          this.showLunbo=false
          this.showImage=true
          this.showJjfa=false
          this.alwaysShowJjfa=false
          this.bannerSrc=this.solutionBnnerSrc
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/classicCase"){
          this.showLunbo=false
          this.showImage=true
          this.showJjfa=false
          this.alwaysShowJjfa=false
          this.bannerSrc=this.solutionBnnerSrc
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/recruitment"){
          this.showLunbo=false
          this.showImage=true
          this.showJjfa=true
          this.alwaysShowJjfa=true
          this.bannerSrc=this.zpBannerSrc
          this.kkLogo=require('../../assets/img/blue-logo.png')
        }else if(to.path=="/main/caseDetails"){
          this.showLunbo=false
          this.showImage=false
          this.showJjfa=true
          this.alwaysShowJjfa=true
          this.kkLogo=require('../../assets/img/blue-logo.png')
        }
      },
      // showLunbo(newVal){
      //   if(newVal&&this.currentLunboIndex==0){
      //     document.getElementById("lunboVideo").play();
      //   }else{
      //     document.getElementById("lunboVideo").pause();
      //   }
      // }
    },
    created() {
      let to=this.$route;
      if(to.path=="/main/desktop"){
        this.showLunbo=true
        this.showImage=false
        this.showJjfa=false
        this.alwaysShowJjfa=false
        this.kkLogo=require('../../assets/img/white-logo.png')
      }else if(to.path=="/main/news"){
        document.body.scrollIntoView()
        this.showLunbo=false
        this.showImage=true
        this.showJjfa=false
        this.alwaysShowJjfa=false
        this.kkLogo=require('../../assets/img/white-logo.png')
        this.bannerSrc=this.newsBannerSrc;
      }else if(to.path=="/main/newsDetails"){
        this.showLunbo=false
        this.showImage=false
        this.showJjfa=true
        this.alwaysShowJjfa=true
        this.kkLogo=require('../../assets/img/blue-logo.png')
      }else if(to.path=="/main/joinUs"){
        this.showLunbo=false
        this.showImage=true
        this.showJjfa=true
        this.alwaysShowJjfa=true
        this.bannerSrc=this.joinUsBannerSrc
        this.kkLogo=require('../../assets/img/blue-logo.png')
      }else if(to.path=="/main/solutionAndServices"){
        this.showLunbo=false
        this.showImage=true
        this.showJjfa=false
        this.alwaysShowJjfa=false
        this.bannerSrc=this.solutionBnnerSrc
        this.kkLogo=require('../../assets/img/white-logo.png')
      }else if(to.path=="/main/productDetails"){
        this.showLunbo=false
        this.showImage=true
        this.showJjfa=false
        this.alwaysShowJjfa=false
        this.bannerSrc=this.solutionBnnerSrc
        this.kkLogo=require('../../assets/img/white-logo.png')
      }else if(to.path=="/main/aboutUs"){
        this.showLunbo=false
        this.showImage=true
        this.showJjfa=false
        this.alwaysShowJjfa=false
        this.bannerSrc=this.aboutUsBnnerSrc
        this.kkLogo=require('../../assets/img/white-logo.png')
      }else if(to.path=="/main/solutionDetails"){
        this.showLunbo=false
        this.showImage=true
        this.showJjfa=false
        this.alwaysShowJjfa=false
        this.bannerSrc=this.solutionBnnerSrc
        this.kkLogo=require('../../assets/img/white-logo.png')
      }else if(to.path=="/main/classicCase"){
        this.showLunbo=false
        this.showImage=true
        this.showJjfa=false
        this.alwaysShowJjfa=false
        this.bannerSrc=this.solutionBnnerSrc
        this.kkLogo=require('../../assets/img/white-logo.png')
      }else if(to.path=="/main/recruitment"){
        this.showLunbo=false
        this.showImage=true
        this.showJjfa=true
        this.alwaysShowJjfa=true
        this.bannerSrc=this.zpBannerSrc
        this.kkLogo=require('../../assets/img/blue-logo.png')
      }else if(to.path=="/main/caseDetails"){
        this.showLunbo=false
        this.showImage=false
        this.showJjfa=true
        this.alwaysShowJjfa=true
        this.kkLogo=require('../../assets/img/blue-logo.png')
      }
      this.getProductList()
    },
    mounted() {

      var el = window.document.body;//声明一个变量，默认值为body
      let that=this
      window.document.body.onmouseover = function(event){
        el = event.target;//鼠标每经过一个元素，就把该元素赋值给变量eljjfa-fwnav-content
        if(el.className.indexOf("services")>-1){
          that.showJjfa=true
          that.kkLogo=require('../../assets/img/blue-logo.png')
          that.showMenu=true
          that.overJjFa=true
          return;
        }
        if(that.overJjFa&&(el.className.indexOf("jjfa-fw")>-1||el.className.indexOf("nav-menu")>-1||el.className.indexOf("nav-content")>-1||el.className.indexOf("j-class")>-1||el.className.indexOf("top-bar-menu")>-1)){
          that.showJjfa=true
          that.kkLogo=require('../../assets/img/blue-logo.png')
          that.showMenu=true
          return;
        }
        if(el.className.indexOf("m-item")>-1){
          that.showJjfa=true
          that.kkLogo=require('../../assets/img/blue-logo.png')
          that.showMenu=false
          that.overJjFa=false
          return;
        }
        that.showMenu=false
        that.overJjFa=false
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;//为了保证兼容性，这里取两个值，哪个有值取哪一个　　var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;    }
        if(scrollTop==0){
          that.setTop()
        }
      }

      window.onscroll = ()=>{
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;//为了保证兼容性，这里取两个值，哪个有值取哪一个　　var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;    }
        if(scrollTop==0&&!this.alwaysShowJjfa){
          this.showJjfa=false
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else{
          this.showJjfa=true
          this.kkLogo=require('../../assets/img/blue-logo.png')
        }
        //控制指定图片的显示
        if(document.getElementById("zd")){
          if(scrollTop>800){
            document.getElementById("zd").style.display="inline"
          }else{
            document.getElementById("zd").style.display="none"
          }
        }
        //首页数字动画效果
        this.scrollToTop()
        //侧边栏定位
        this.scollSecondaryMenu()
        this.setSecondaryMenu()
      }
      //设置首页轮播图高度{
      this.setLunbo()
      window.onresize =()=>{
        this.setLunbo()
      }

    },
    methods: {
      sortCp(){
        this.managementList=this.managementList.sort((a,b)=>{
          return b.publish_time-a.publish_time
        })
        this.businessList=this.businessList.sort((a,b)=>{
          return b.publish_time-a.publish_time
        })
        this.marketingList=this.marketingList.sort((a,b)=>{
          return b.publish_time-a.publish_time
        })
        this.platformList=this.platformList.sort((a,b)=>{
          return b.publish_time-a.publish_time
        })
      },
      clickLogo(){
        this.$router.push({
          path:"/main"
        })
      },
      setLunbo(){
        this.lunboImageStyle.width= $(window).width()>1200?$(window).width()+"px":"1200px"
        let _lunboHeight=$(window).width()/1920*950+"px"
        this.$nextTick(()=>{
          this.lunboHeight=_lunboHeight
        })


      },
      setSecondaryMenu(){
        // 获取视窗高度
        var domHight = document.body.offsetHeight;
        // dom滚动位置
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // 获取监听元素本身高度
        var scrollHeight;
        // 获取监听元素距离视窗顶部距离
        var offsetTop;
        // 获取监听元素距离顶部高度-窗口高度
        var top;
        // 元素距离底部的高度+元素本身高度
        var bottom;

        var id = document.getElementById("t1");
        var id2= document.getElementById("t2");
        var id3= document.getElementById("t3");
        var id4= document.getElementById("t4");
        var id5= document.getElementById("t5");
        var id6= document.getElementById("t6");
        if(!id&&!id2&&!id3&&!id4&&!id5&&!id6){
          return;
        }
        if(this.$route.path=="/main/recruitment"){
          if(id){
            scrollHeight = id.scrollHeight;
            offsetTop = id.offsetTop;
            // console.log($("#id3").offset().top)
            top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
            bottom = scrollHeight + offsetTop;
            // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
            if (scrollTop >=  top&& scrollTop <= bottom) {

              $("#_t1").siblings().removeClass("li-selected")
              $("#_t1").addClass("li-selected")
              return;
            }
          }
          if(id2){
            scrollHeight = id2.scrollHeight;
            offsetTop = id2.offsetTop;
            // console.log($("#id3").offset().top)
            top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
            bottom = scrollHeight + offsetTop;
            // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
            if (scrollTop >=  top&& scrollTop <= bottom) {

              $("#_t2").siblings().removeClass("li-selected")
              $("#_t2").addClass("li-selected")
              return;
            }
            if(id3){
              scrollHeight = id3.scrollHeight;
              offsetTop = id3.offsetTop;
              // console.log($("#id3").offset().top)
              top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
              bottom = scrollHeight + offsetTop;
              // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
              if (scrollTop >=  top&& scrollTop <= bottom) {

                $("#_t3").siblings().removeClass("li-selected")
                $("#_t3").addClass("li-selected")
                return;
              }
            }
            if(id4){
              scrollHeight = id4.scrollHeight;
              offsetTop = id4.offsetTop;
              // console.log($("#id3").offset().top)
              top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
              bottom = scrollHeight + offsetTop;
              // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
              if (scrollTop >=  top&& scrollTop <= bottom) {

                $("#_t4").siblings().removeClass("li-selected")
                $("#_t4").addClass("li-selected")
                return;
              }
            }
            if(id5){
              scrollHeight = id5.scrollHeight;
              offsetTop = id5.offsetTop;
              // console.log($("#id3").offset().top)
              top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
              bottom = scrollHeight + offsetTop;
              // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
              if (scrollTop >=  top&& scrollTop <= bottom) {

                $("#_t5").siblings().removeClass("li-selected")
                $("#_t5").addClass("li-selected")
                return;
              }
            }
            if(id6){
              scrollHeight = id6.scrollHeight;
              offsetTop = id6.offsetTop;
              // console.log($("#id3").offset().top)
              top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
              bottom = scrollHeight + offsetTop;
              // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
              if (scrollTop >=  top&& scrollTop <= bottom) {
                $("#_t6").siblings().removeClass("li-selected")
                $("#_t6").addClass("li-selected")
                return;
              }
            }
          }
          return;
        }
        if(id6){
          scrollHeight = id6.scrollHeight;
          offsetTop = id6.offsetTop;
          // console.log($("#id3").offset().top)
          top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
          bottom = scrollHeight + offsetTop;
          // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
          if (scrollTop >=  top&& scrollTop <= bottom) {
            $("#_t6").siblings().removeClass("li-selected")
            $("#_t6").addClass("li-selected")
            return;
          }
        }
        if(id5){
          scrollHeight = id5.scrollHeight;
          offsetTop = id5.offsetTop;
          // console.log($("#id3").offset().top)
          top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
          bottom = scrollHeight + offsetTop;
          // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
          if (scrollTop >=  top&& scrollTop <= bottom) {

            $("#_t5").siblings().removeClass("li-selected")
            $("#_t5").addClass("li-selected")
            return;
          }
        }
        if(id4){
          scrollHeight = id4.scrollHeight;
          offsetTop = id4.offsetTop;
          // console.log($("#id3").offset().top)
          top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
          bottom = scrollHeight + offsetTop;
          // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
          if (scrollTop >=  top&& scrollTop <= bottom) {

              $("#_t4").siblings().removeClass("li-selected")
              $("#_t4").addClass("li-selected")
              return;
          }
        }
        if(id3){
          scrollHeight = id3.scrollHeight;
          offsetTop = id3.offsetTop;
          // console.log($("#id3").offset().top)
          top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
          bottom = scrollHeight + offsetTop;
          // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
          if (scrollTop >=  top&& scrollTop <= bottom) {

            $("#_t3").siblings().removeClass("li-selected")
            $("#_t3").addClass("li-selected")
            return;
          }
        }
        if(id2){
          scrollHeight = id2.scrollHeight;
          offsetTop = id2.offsetTop;
          // console.log($("#id3").offset().top)
          top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
          bottom = scrollHeight + offsetTop;
          // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
          if (scrollTop >=  top&& scrollTop <= bottom) {

            $("#_t2").siblings().removeClass("li-selected")
            $("#_t2").addClass("li-selected")
            return;
          }
        }
        if(id){
          scrollHeight = id.scrollHeight;
          offsetTop = id.offsetTop;
          // console.log($("#id3").offset().top)
          top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
          bottom = scrollHeight + offsetTop;
          // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
          if (scrollTop >=  top&& scrollTop <= bottom) {

            $("#_t1").siblings().removeClass("li-selected")
            $("#_t1").addClass("li-selected")
            return;
          }
        }
      },
      scollSecondaryMenu(){
        var banner = document.getElementById("banner");
        var menu=document.getElementById("secondaryMenu")
        if(!banner||!menu){
          return;
        }
        // 获取视窗高度
        var domHight = document.body.offsetHeight;
        // dom滚动位置
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // 获取监听元素本身高度
        var scrollHeight;
        // 获取监听元素距离视窗顶部距离
        var offsetTop;
        // 获取监听元素距离顶部高度-窗口高度
        var top;
        // 元素距离底部的高度+元素本身高度
        var bottom;

        scrollHeight = banner.scrollHeight;
        offsetTop = banner.offsetTop;
        top = offsetTop - domHight> 0 ? offsetTop - domHight : 0;
        bottom = scrollHeight + offsetTop;
        // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
        if ((scrollTop+67) >= top && (scrollTop+67) <= bottom) {
          menu.style.position=""
          menu.style.top=""
          menu.style.height="380px"
        } else {
            menu.style.position="fixed"
            menu.style.top="100px"
            menu.style.height="290px"
        }
      },
      scrollToTop() {
        // 获取视窗高度
        var domHight = document.body.offsetHeight;
        // dom滚动位置
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // 获取监听元素
        var id;
        // 获取监听元素本身高度
        var scrollHeight;
        // 获取监听元素距离视窗顶部距离
        var offsetTop;
        // 获取监听元素距离顶部高度-窗口高度
        var top;
        // 元素距离底部的高度+元素本身高度
        var bottom;

        id = document.getElementById("data-number");
        var id2= document.getElementById("data-number2");
        var id3= document.getElementById("data-number3");
        if(!id){
          return;
        }
        scrollHeight = id.scrollHeight;
        offsetTop = id.offsetTop;
        top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
        bottom = scrollHeight + offsetTop;
        // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
        if (scrollTop >= top && scrollTop <= bottom) {
              if(this.calculated){
                return
              }else{
                this.calculated=true
              }
             let t=window.setInterval(()=>{
                 let num=parseInt(id.innerHTML)
                 if(num==20)
                 {
                   window.clearInterval(t)
                 }else{
                   id.innerHTML=num+1
                 }
             },50)
            let t2=window.setInterval(()=>{
              let num2=parseInt(id2.innerHTML)
              if(num2>=200)
              {
                id2.innerHTML=200
                window.clearInterval(t2)
              }else{
                id2.innerHTML=num2+13
              }
            },50)
            let t3=window.setInterval(()=>{
              let num3=parseInt(id3.innerHTML)
              if(num3>=3000)
              {
                id3.innerHTML=3000
                window.clearInterval(t3)
              }else{
                id3.innerHTML=num3+188
              }
            },50)
        } else {
          id.innerHTML="1";
          id2.innerHTML="1";
          id3.innerHTML="1";
          this.calculated=false
        }
      },
      //设置头部导航栏样式
      setTop(){
        let to=this.$route;
        if(to.path=="/main/desktop"){
          this.showJjfa=false
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/news"){
          this.showJjfa=false
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/newsDetails"){
          this.showJjfa=true
          this.kkLogo=require('../../assets/img/blue-logo.png')
        }else if(to.path=="/main/joinUs"){
          this.showJjfa=true
          this.kkLogo=require('../../assets/img/blue-logo.png')
        }else if(to.path=="/main/solutionAndServices"){
          this.showJjfa=false
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/productDetails"){
          this.showJjfa=false
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/aboutUs"){
          this.showJjfa=false
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/solutionDetails"){
          this.showJjfa=false
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/classicCase"){
          this.showJjfa=false
          this.kkLogo=require('../../assets/img/white-logo.png')
        }else if(to.path=="/main/recruitment"){
          this.showJjfa=true
          this.kkLogo=require('../../assets/img/blue-logo.png')
        }else if(to.path=="/main/caseDetails"){
          this.showJjfa=true
          this.kkLogo=require('../../assets/img/blue-logo.png')
        }
      },
      clickBanner(){
        localStorage.setItem("xl","secondaryMenu")
            if(this.bannerSrc=='/static/img/join-us-banner.3a22ab2.jpg'&&!this.showLunbo){
              this.$router.push({
                path:"/main/recruitment"
              })
            }
      },
       getProductTitle(p){
         if(this.currentType==5){
           return p.solution_title
         }else{
           return p.prodinfo_title
         }
       },
       clickProduct(p){
         this.showMenu=false
         this.overJjFa=false
         localStorage.setItem("xl","p-title")
           if(this.currentType==5){
             this.$router.push({
               path:"/main/solutionDetails",
               query:{
                 solutionId:p.solution_id
               }
             })
           }else{
             this.$router.push({
               path:"/main/productDetails",
               query:{
                 type:this.productClassList[this.currentType-1],
                 prodinfo_id:p.prodinfo_id
               }
             })
           }
       },
       clickClass(type){
         this.currentType=type
         if(type==1){
           this.productList=this.managementList
         }else if(type==2){
           this.productList= this.businessList
         }else if(type==3){
           this.productList=this.marketingList
         }else if(type==4){
           this.productList=this.platformList
         }else{
           this.productList=this.solutionList
         }
       },
       getProductList(){
         //获取产品列表和解决方案列表
         let data={
           url:"/getProdTitleByClassify.json"
         }
         request.post(data).then(res=>{
           this.managementList=[]
           this.marketingList=[]
           this.platformList=[]
           this.businessList=[]
           res.data.rows.map(item=>{
             if(item.prod_classify=="1"){
               this.managementList.push(item)
             }else if(item.prod_classify=="2"){
               this.businessList.push(item)
             }else if(item.prod_classify=="3"){
               this.marketingList.push(item)
             }else{
               this.platformList.push(item)
             }
           })
           this.sortCp()
           this.productList=this.businessList
         })
         let data2={
           url:"/getSoluTitleListByReleaseStatus.json"
         }
         request.post(data2).then(res=>{
           this.solutionList=res.data
         })
       },
       mouseoverJjfa(){
         this.showJjfa=true
         this.kkLogo=require('../../assets/img/blue-logo.png')
         this.showMenu=true
       },
       mouseoutJjfa(){
         this.showMenu=false
         if(this.alwaysShowJjfa){
           return
         }else{
           this.showJjfa=false
           this.kkLogo=require('../../assets/img/white-logo.png')
         }
       },
       changeLb(num){
        // this.currentLunboIndex=num
        //  if(num==0){
        //     if(this.showLunbo){
        //       document.getElementById("lunboVideo").play()
        //     }
        //  }else{
        //    document.getElementById("lunboVideo").pause();
        //  }
       },
       clickBar(num){
         if(num==0){
           localStorage.setItem("top","true")
           this.$router.push({
             path:"/main"
           })
         }else if(num==3){
             this.showMenu=false
             this.overJjFa=false
             localStorage.setItem("xl","m-service")
             this.$router.push({
               path:"/main/solutionAndServices"
             })
         }else if(num==4){
             localStorage.setItem("xl","gsdt")
             this.$router.push({
               path:"/main/news"
             })
         }else if(num==5){
           localStorage.setItem("xl","secondaryMenu")
           this.$router.push({
             path:"/main/joinUs"
           })
         }else if(num==1){
           localStorage.setItem("xl","secondaryMenu")
           this.$router.push({
             path:"/main/aboutUs"
           })
         }else if(num==2){
           localStorage.setItem("xl","classic-case")
           this.$router.push({
             path:"/main/classicCase"
           })
         }
       }
    }
  };
</script>

<style lang="scss" scoped>
  .services{
    .services:after,.services{
      //border-bottom: 2px solid #2061CA;
    }
    .jjfa-fw{
    width: 710px;
    display: flex;
    flex-direction: row;
    position: absolute;
    top: 52px;
    font-family:PingFangSC-Medium,PingFang SC;
    .nav-menu{
      padding: 5px 0px;
      margin: 0;
      width: 110px !important;
      height: 235px !important;
      display: flex;
      flex-direction: column !important;
      li{
        width: 100% !important;
        height:20px;
        padding-left: 30px;
        font-size:13px !important;
        font-weight:500;
        color:rgba(246,249,250,1) !important;
        line-height:20px;
        img{
          margin-left: 7px;
        }
      }
    }
    .nav-content{
      width: 600px;
      height: 235px !important;
      background-color: #FFFFFF;
      padding: 25px 0px 25px 36px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      span{
        width: 155px;
        height:18px;
        font-size:13px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(122,122,122,1);
        line-height:18px;
        margin-right: 30px;
      }
    }

}
    @media screen and (max-width:1400px){
      .jjfa-fw{
        .nav-menu{
           width: 100px !important;
        }
        .nav-content{
          width: 450px !important;
        }
      }
    }
  }
 /deep/ .el-carousel{
    width: 100%;
  }

 /deep/ .el-carousel__indicators--horizontal{
     bottom: 180px;
     li{
       width: 80px;
       height: 8px;
     }
  }


  .image{
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    .find-job{
      cursor: pointer;
    }
    .el-image{
      width: 100%;
    }
    .video{
      width: 100%;
    }
    .image-order{
      display: flex;
      width: auto;
      justify-content: center;
      position: absolute;
      bottom: 200px;
      div{
        width: 80px;
        height: 8px;
        background-color: white;
        margin-right: 40px;
        border-radius: 4px;
      }
    }
  }

  .top{
    width: 100%;
    position: relative;
    min-width: 1200px;
    min-height: 60px;
    .lbwz{
      position: absolute;
      z-index: 2000;
      top: 40%;
      left: 30%;
    }
    .top-bar{
       position: fixed;
       z-index:2000;
       top:0px;
       min-width: 1300px;
       width: 100%;
       display: flex;
       .bw{
         width: 1200px;
         margin: 0 auto;
         display: flex;
         flex-direction: row;
         .kkws-icon{
           width: 20%;
           display: flex;
           justify-content: center;
           align-items: center;
           margin-right: 17%;
           margin-top: 1%;
           cursor: pointer;
           .el-image{
             width: 231px;
             height: 55px;
           }
         }
         .top-bar-menu{
           width: 66%;;
           ul{
             width: 100%;
             display: flex;
             justify-content: space-between;
             flex-direction: row;
             align-items: center;
             li {
               list-style: none; /*使li前面的小圆点消失*/
               cursor:pointer;
               width:auto;
               font-family:PingFangSC-Medium,PingFang SC;
               color: #FFFFFF;
               font-size: 18px;
               font-weight: 500;
               height: 38px;
               line-height: 38px;
             }
           }
           .m-item:hover{
             color: #00bbff !important;
           }
         }
       }
    }

  }

  .jjfa{
    background:rgba(255,255,255,1);
    box-shadow:0px 6px 8px 0px rgba(217,217,217,0.5);
    li{
      color:rgba(122,122,122,1) !important;
    }
  }

  .top-ff-tip{
    width: 100%;
    padding: 10px 30px;
    background-color: #DCE9FD;
    position: fixed;
    top: 67px;
    z-index: 990;
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #000;
    a{
      cursor: pointer;
      color: #000;
      text-decoration: none;
    }
    img{
      position: absolute;
      top: 12px;
      right: 10px;
      cursor: pointer;
    }
  }

</style>



// WEBPACK FOOTER //
// src/frame/main/TopNavbar.vue